import { createSlice } from "@reduxjs/toolkit";
import { makeThunk } from "helpers/makeThunk";
import { handleCommonCases } from "helpers/thunkHandler";
import {
  GET_BRANCH_CAMERA_LIST,
  GET_BRANCH_CAMERA_DETAILS,
  DELETE_BRANCH_CAMERA,
} from "helpers/url_helper";

// LIST — POST branch-camera/list { branchId }
export const getBranchCameras = makeThunk({
  type: "branchCamera/getList",
  url: GET_BRANCH_CAMERA_LIST,
  method: "post",
});

// DETAILS — GET branch-camera/:branchId/:id
export const getBranchCameraDetails = makeThunk({
  type: "branchCamera/getDetails",
  url: ({ branchId, id }) => `${GET_BRANCH_CAMERA_DETAILS}/${branchId}/${id}`,
  method: "get",
});

// DELETE — DELETE branch-camera/:branchId/:id
export const deleteBranchCamera = makeThunk({
  type: "branchCamera/delete",
  url: ({ branchId, id }) => `${DELETE_BRANCH_CAMERA}/${branchId}/${id}`,
  method: "delete",
});

const initialState = {
  loading: false,
  isDeleting: false,
  loadingItemId: null,
  items: [],
  itemDetails: {},
};

const branchCameraSlice = createSlice({
  name: "branchCamera",
  initialState,
  reducers: {
    clearItemDetails: (state) => {
      state.itemDetails = {};
    },
  },
  extraReducers: (builder) => {
    handleCommonCases(builder, getBranchCameras, {
      onFulfilled: (state, action) => {
        console.log("getBranchCameras action.payload", action.payload);
        state.items = action.payload?.data?.cameras || [];
      },
    });

    handleCommonCases(builder, getBranchCameraDetails, {
      onPending: (state) => {
        state.itemDetails = {};
      },
      onFulfilled: (state, action) => {
        state.itemDetails = action.payload?.data || {};
      },
    });

    handleCommonCases(builder, deleteBranchCamera, {
      loadingKey: "isDeleting",
      onFulfilled: (state, action) => {
        const { id } = action.meta.arg || {};
        state.items = state.items.filter((item) => item._id !== id);
      },
    });
  },
});

export const { clearItemDetails } = branchCameraSlice.actions;
export default branchCameraSlice.reducer;
